import { useState, useEffect, useCallback } from 'react';
import {
  hideTrack as hideTrackService,
  getHiddenTracks,
} from '@/lib/hiddenTracksService';

export function useHiddenTracks(userId: string) {
  const [hiddenTrackIds, setHiddenTrackIds] = useState<string[]>([]);

  useEffect(() => {
    async function loadHiddenTracks() {
      const { tracks } = await getHiddenTracks(userId);
      setHiddenTrackIds(tracks);
    }

    loadHiddenTracks();
  }, [userId]);

  const hideTrack = useCallback(
    async (trackId: string) => {
      const { error } = await hideTrackService(userId, trackId);
      if (!error) {
        setHiddenTrackIds(prev => [...prev, trackId]);
        return true;
      }
      return false;
    },
    [userId]
  );

  return { hiddenTrackIds, hideTrack };
}
